// extracted by mini-css-extract-plugin
export default {"container":"of","header":"pf","logodesktop":"qf","logomobile":"rf","imgcontainer":"sf","slidercontainer":"tf","slick-slider":"uf","slick-initialized":"vf","sliderbox":"wf","headline":"xf","mainheadline":"yf","capitalize":"zf","desc":"Af","descitalic":"Bf","desccenter":"Cf","descborder":"Ef","subdesc":"Ff","welcomeslide":"Gf","desccard":"Hf","img":"If","button":"Jf","buttonskip":"Kf","customPosition":"Lf"};
    if(module.hot) {
      // 1715632477185
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  